import { useEffect, useState } from "react";
import { fetchPressroom } from "@/api/publicist";

type PressroomEntry = {
  title: string;
  artist: string;
  release_date?: string | null;
  summary: string;
};

export default function PressroomPage() {
  const [entries, setEntries] = useState<PressroomEntry[]>([]);

  useEffect(() => {
    fetchPressroom()
      .then((data) => setEntries(data ?? []))
      .catch(() => setEntries([]));
  }, []);

  return (
    <div className="aa-page-shell space-y-4">
      <header className="space-y-1">
        <p className="text-xs uppercase tracking-wide text-primary">Pressroom</p>
        <h1 className="aa-page-title text-3xl font-semibold">Published <span className="aa-gradient-text">Releases</span></h1>
        <p className="text-sm text-muted-foreground">Approved press releases ready for public consumption.</p>
      </header>

      <div className="space-y-4">
        {entries.map((entry, index) => (
          <article key={`${entry.title}-${index}`} className="aa-glass-card rounded-2xl p-4">
            <p className="text-xs uppercase tracking-wide text-muted-foreground">{entry.artist}</p>
            <h2 className="text-2xl font-semibold text-foreground">{entry.title}</h2>
            {entry.release_date && <p className="text-xs text-muted-foreground">Release date: {entry.release_date}</p>}
            <p className="mt-2 text-sm text-foreground/80">{entry.summary}…</p>
          </article>
        ))}
        {!entries.length && <p className="text-sm text-muted-foreground">No published releases yet.</p>}
      </div>
    </div>
  );
}
